module.exports = __webpack_public_path__ + "static/media/spoonerism-task (8).806124f9.mp3";